var jQuery=$=require('jquery');
    module.exports = {
       // props: ['hotelId'],
        data:function(){
            return {
            	hotel: '',
	            isShow: 0,
	            param:'',
                num:'',
                isconfirm:false,
	            url : this.baseApiPath,
	            user:localStorage['username'],
	            amenities: [],
                amentags:[],
                peicalService: [],
                showCheck:{}
             }
        },
         //计算属性
         computed:{
        },
        ready:function(){
             this.param = this.$route.params.id;
            this.hotel = this.param;
            var data = {
                method: 'amenserv_amenity',
                token: localStorage['token'],
                hotel: this.param
            }
            var jqPromise = $.post(this.url, data);
            var realPromise = Promise.resolve(jqPromise),
            that = this;
            realPromise.then(function(value) {
                var value = JSON.parse(value)
               // $('.roomsummary .panel-body').html(value.data.roomsummary);
                return value;
            }).then(function(value) {

                that.amenities = value.data || [{
                hotel: '',
                checked:0,
                name: '新建房间',
                intro:[{pic:'',text:''}]
            }];

            console.log(that.amenities);
            var check = $('.checkbox_list input[type="checkbox"]:checked'),
                checkArr = new Array();
            for (var i = 0; i < check.length; i++) {
                checkArr.push(check.eq(i).attr('data-text'));
            };
            that.amentags = '';
            that.amentags=that.amenities&&that.amenities.filter(function(x){
                   return x.checked==1
            })
             that.showCheck={}
             that.amentags[0]&&that.amentags.map(function(x){
                that.showCheck[x.name]=1
             })

             $('.checkbox_list input').map(function(x){
                var text=$(this).data('text')
                    if (that.showCheck[text]==1) {
                        this.checked=1
                    }else{
                        this.checked=0
                    }
                })
                return value;
            })
                
        },
         attached:function(){
            var that=this;
            $('.container-fluid').on('change','input',function(){
                that.isconfirm=true;
            });
            $('.container-fluid').on('change','textarea',function(){
                that.isconfirm=true;
            });

        },
        methods: {

            uploadhandle:function(e){
                var that=this;
                 var fileList = e.target.files;
                //console.log(files)
                var reader=new FileReader();
              //  console.log(that.num)
                if(fileList[0]&& fileList[0].type&& fileList[0].type.match('image.*')){
                    reader.readAsDataURL(fileList[0]);
                  }
                reader.onload = (function(file){
                    return function(e){
                      //  console.log(that.num)
                        var dataURL = reader.result;
                        var data = {
                            method: 'picture_upload',
                            token: localStorage['token'],
                            file: dataURL,
                            name:fileList[0].name
                        }
                        var jqPromise = $.post(that.baseApiPath, data);
                        var realPromise = Promise.resolve(jqPromise);
                        realPromise.then(function(value){
                            var value= JSON.parse(value);
                            that.amenities[that.isShow].intro[that.num].pic=value.data.file
                        }) 
                    }
                // console.log(reader.result)
                // console.log(dataURL)

                //  var output = document.getElementById('output');
                // for(var item in input.files){

                  // }
                 //  var str = "<img data-id='123145' src='"+dataURL+"'>";
                 //  $('#output').append(str);
                 // console.log(str)
                 //  output.src = dataURL;
                })(fileList[0])
            },
           uploadpic :function(num){
            this.num=num;
           // console.log(num)
            $('.deshandle:eq('+num+')').trigger('click');
           },
            removeservice:function(n){
                this.tags.splice(n,1)
            },
            addamenities: function() {
                console.log(111)
                var that = this;
                var p1 = new Promise(function(resolve, reject) {
                    resolve('success')
                })
                p1.then(function(value) {
                    that.amenities.push({
                        hotel: '',
                        name: '',
                        checked:0,
                        intro:[{pic:'',text:''}]
                    });
                    return value;
                })
                // .then(function(value) {
                //     $('.specialnote').summernote({
                //         height: 100
                //     });
                //     return value
                // })
                .then(function(value) {
                    that.isShow = that.amenities.length - 1
                })
            },
            changeamenities: function(num) {
                this.isShow = num
            },
            delamenities: function(num) {
                if (num == this.amenities.length - 1) {
                    this.isShow = this.amenities.length - 2
                }
                this.amenities.splice(num, 1)
                this.isconfirm=true;
            },
            delpic:function(num){
                this.amenities[this.isShow].intro.splice(num,1)
                that.isconfirm=true;
            },
            addContent:function(num){
                this.amenities[num].intro.push({pic:'',text:''})

            },
            amenitiesSubmit: function() {
                var passed=this.amenities.some(function(x){
                    return x.name==''||undefined||null;
                })
                if(passed){
                    alert('请确保所有设施都具有名称')
                    return;
                }
                var tags=[];
                 $('.checkbox_list input').map(function(x){
                    var text=$(this).data('text')
                    if ( this.checked==1) {
                       tags.push({name:text,checked:1})
                    }
                 })
                 console.log(tags)
                 console.log(this.amenities)
                var data = {
                    method: 'amenserv_update_amenity',
                    token: localStorage['token'],
                    hotel: this.hotel,
                    amenities: this.amenities.filter(function(x){
                   return x.checked==0
                }).concat(tags)
                };
                var jqPromise = $.post(this.url, data);
                var realPromise = Promise.resolve(jqPromise),
                    that = this;
                realPromise.then(function(value) {
                        // console.log(value)
                    var value = JSON.parse(value);
                    if (value.code == 0) {
                       // console.log(value)
                           //  window.location.href='service.html?id='+that.param;
                           that.isconfirm=false;
                           that.$route.router.go({name:'service',params:{id:that.param}})

                    } else {
                        alert(value.message)
                    }
                })
            }
           },
        route:{
            activate:function(transtition){
            	window.scrollTo(0,0);
                transtition.next()
            },
            canDeactivate:function(transition){
                if(this.isconfirm){
                    if(confirm('还未保存，确定退出？')){
                        transition.next()
                    }else{
                        transition.abort()
                    }
                }else{
                    transition.next()
                }
                
            },
            data: function() {
            this.param = this.$route.params.id;
            this.hotel = this.param;
            this.$dispatch('pageinfo','酒店活动');
            var data = {
                method: 'amenserv_amenity',
                token: localStorage['token'],
                hotel: this.param
            }
            var jqPromise = $.post(this.url, data);
            var realPromise = Promise.resolve(jqPromise),
                that = this;
            realPromise.then(function(value) {
                var value = JSON.parse(value)
               // $('.roomsummary .panel-body').html(value.data.roomsummary);
                return value;
            }).then(function(value) {
                that.amenities = value.data|| [{
                    hotel: '',
                    name: 'test',
                    intro:[{pic:'',text:''}]
                }]

                return value;
            })
            // .then(function(){
            //     // 根据下表删除数组
            //     Array.prototype.remove=function(obj){ 
            //         for(var i =0;i <this.length;i++){ 
            //             var temp = this[i]; 
            //             if(!isNaN(obj)){ 
            //                 temp=i; 
            //             } 
            //             if(temp == obj){ 
            //                 for(var j = i;j <this.length;j++){ 
            //                     this[j]=this[j+1]; 
            //                 } 
            //                 this.length = this.length-1; 
            //             } 
            //         } 
            //     }
            // })

            .then(function(value){
                that.amentags=that.amenities&&that.amenities.filter(function(x){
                   return x.checked==1
                })
                that.showCheck={}
                that.amentags[0]&&that.amentags.map(function(x){
                    that.showCheck[x.name]=1
                })
                $('.checkbox_list input').map(function(x){
                    var text=$(this).data('text')
                    if (that.showCheck[text]==1) {
                       this.checked=1
                    }else{
                       this.checked=0
                    }
                })
                // alert('s');
                var checkArr = new Array(),
                    tabArr = new Array(),
                    check = $('.checkbox_list input[type="checkbox"]:checked'),
                    tab = $('.snav .roomtab'),
                    arrs = new Array();

                for (var i = 0; i < check.length; i++) {
                    checkArr.push(check.eq(i).attr('data-text'));
                    console.log(checkArr)
                };

                for(var i = 0 ; i < tab.length; i++) {
                    tabArr.push(tab.eq(i).find('a').text().trim());
                    console.log(tabArr);
                }
                // return false;
                // alert('ss')
                for (var i = 0; i < tabArr.length; i++) {
                    // debugger;
                    for (var k = 0; k < checkArr.length; k++) {
                        // debugger;
                        if(tabArr[i] === checkArr[k]) {
                            // debugger;
                            for (var s = 0; s < tab.length; s++) {
                                // debugger;
                                if(tab.eq(s).find('a').text().trim() == tabArr[i]) {
                                    // tab.eq(s).addClass('hidess');
                                    // alert(s)
                                    arrs.push(s);
                                }
                            };
                        }else{

                        }
                    };

                };
                console.log(arrs);
                for (var i = 0; i < arrs.length; i++) {
                    $('.roomtab').eq(arrs[i]).hide();
                    // console.log(arrs[i])
                };
            })

        },
        }
    }


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/views/facilities.vue
// module id = 91
// module chunks = 0